import type { Language } from '../types/index.js';

/**
 * BCP-47 locale per app language, for dates, numbers and currency.
 *
 * Lives in shared because both sides need it: the client formats what it
 * renders, and the server formats the copy it composes itself (notification
 * times, saved amounts). Before this existed the server hard-coded `es-ES`,
 * so a Hungarian user got Spanish-style times and thousands separators.
 */
const LOCALE_BY_LANG: Record<string, string> = {
  es: 'es-ES',
  ca: 'ca-ES',
  'ca-valencia': 'ca-ES-valencia',
  en: 'en-GB',
  hu: 'hu-HU',
  eu: 'eu-ES',
  it: 'it-IT',
  tr: 'tr-TR',
};

/** The BCP-47 locale for an app language; Spanish when unknown or absent. */
export function localeFor(lang: Language | string | null | undefined): string {
  return (lang && LOCALE_BY_LANG[lang]) || 'es-ES';
}
